import { FolderOpenTwoTone, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Spin, Tree } from 'antd';
import type { DataNode } from 'antd/es/tree';
import { useFormik } from 'formik';
import { Key, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { Loader } from 'react-clip-loader';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { ContentHeader } from "../../components";
import { arrayCommon } from '../../helpers/common';
import { ChucNangResponse } from '../../models/chucnang/ChucNang';
import { layDanhSachChucNangTreeView, luuChucNang, xoaChucNang } from '../../services/chucnang';
import ChucNangSelectTree from '../utils/ChucNangSelectTree';

const convertDataTreeView = (data: any) => {
    let chidlrenArr: Array<DataNode> = [];
    if (data) {
        chidlrenArr = data.map((_item: any) => {
            let rs: DataNode = {

                key: _item?.id,
                title: _item?.tenChucNang,
                icon: <FolderOpenTwoTone style={{ fontSize: "20px" }} rev="" />,
                children: convertDataTreeView(_item?.children)
            }
            return rs;
        })
    }
    return chidlrenArr;
}
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin rev="" />;
const DanhSachChucNang = () => {
    const [loading, setLoading] = useState(false);
    const [dsChucNang, setDsChucNang] = useState<Array<ChucNangResponse>>([]);
    const [openModalXoa, setOpenModalXoa] = useState<number>(-1);
    const [chucNangShow, setChucNangShow] = useState<ChucNangResponse | null | undefined>(null);
    const [chucNangSelected, setChucNangSelected] = useState<number>(0);
    const [treeData, setTreeData] = useState<Array<DataNode>>([]);
    const [loadingTree, setLoadingTree] = useState<boolean>(false);
    const [showBtnXoa, setShowBtnXoa] = useState<boolean>(false);
    const [reloadTree, setReloadTree] = useState<boolean>(true);
    const { handleChange, values, handleSubmit, touched, errors, setFieldValue, setErrors, setTouched } = useFormik({
        initialValues: {
            "id": 0,
            "tenChucNang": "",
            "moTa": "",
            "controllerName": "",
            "actionName": "",
            "idCha": 0,
            "thuTu": 1,
            "url": "",
            "hienThi": false,
            "kichHoat": true,
            "icon": ""
        },
        validationSchema: Yup.object({
            tenChucNang: Yup.string().required('Bắt buộc'),
            thuTu: Yup.number().integer().min(1, "Thứ tự lớn hơn 0")
        }),
        onSubmit: (values) => {
            submitLuu(values);
        }
    });
    const onChange = (e: any) => {
        var { name, value } = e.target;
        setFieldValue(name, value);
    };
    const submitLuu = async (value: any) => {
        try {
            setLoading(true);
            await luuChucNang(value);
            setLoading(false);
            setErrors({});
            setTouched({});
            setReloadTree(true);
            toast.success("Lưu thành công!");
        }
        catch (error: any) {
            setLoading(false);
            setErrors({});
            setTouched({});
            toast.error(error.message || "Vui lòng thử lại");
        };
    }
    const onSelect = (selectedKeys: Key[], info: any) => {
        var dv = arrayCommon.findById(dsChucNang, selectedKeys[0]);
        if (dv != null || dv != undefined) {
            setChucNangSelected(dv["id"] || 0);
            setErrors({});
            setTouched({});
            setShowBtnXoa(true);
            setFieldValue("id", dv["id"] || 0);
            setFieldValue("tenChucNang", dv["tenChucNang"] || "");
            setFieldValue("moTa", dv["moTa"] || "");
            setFieldValue("controllerName", dv["controllerName"] || "");
            setFieldValue("actionName", dv["actionName"] || "");
            setFieldValue("idCha", dv["idCha"] || 0);
            setFieldValue("thuTu", dv["thuTu"] || 1);
            setFieldValue("url", dv["url"] || "");
            setFieldValue("hienThi", dv["hienThi"] || false);
            setFieldValue("kichHoat", dv["kichHoat"] || false);
            setFieldValue("icon", dv["icon"] || "");
        } else {
            onThemMoi();
        }
    };
    const onThemMoi = () => {
        setErrors({});
        setTouched({});
        setChucNangSelected(0);
        setShowBtnXoa(false);
        setFieldValue("id", 0);
        setFieldValue("idCha", values.id || 0);
        setFieldValue("tenChucNang", "");
        setFieldValue("moTa", "");
        setFieldValue("controllerName", "");
        setFieldValue("actionName", "");
        setFieldValue("thuTu", 1);
        setFieldValue("url", "");
        setFieldValue("hienThi", false);
        setFieldValue("kichHoat", false);
        setFieldValue("icon", "");
    }
    const laydsChucNang = async () => {
        try {
            setLoadingTree(true);
            let data = await layDanhSachChucNangTreeView();
            setDsChucNang(data);
            setTreeData(convertDataTreeView(data));
            setLoadingTree(false);
        } catch (error: any) {
            setLoadingTree(false);
        };
    }
    const xoa = async (id: number) => {
        try {
            let temp = await xoaChucNang(id);
            setOpenModalXoa(-1);
            if (temp) {
                toast.success('Xóa chức năng thành công!');
                setChucNangShow(null);
                setReloadTree(true);
            } else {
                toast.error('Xóa chức năng không thành công!');
            }
        }
        catch (error: any) {
            setOpenModalXoa(-1);
            toast.error('Xóa chức năng không thành công!');
            setLoadingTree(false);
        };
    };
    useEffect(() => {
        if (reloadTree) {
            laydsChucNang();
            onThemMoi();
            setReloadTree(false);
        }
    }, [reloadTree]);

    return (<section>
        <Modal show={openModalXoa > -1} onHide={() => setOpenModalXoa(-1)}>
            <Modal.Header closeButton>
                <Modal.Title>Xóa chức năng</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Bạn có muốn xóa chức năng <strong>{chucNangShow?.tenChucNang}</strong> không?
                <br />
                <strong><span className="text-red">Lưu ý:</span></strong> Sẽ xóa các chức năng con liên quan.
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={() => setOpenModalXoa(-1)}>
                    Đóng
                </Button>
                <Button variant="danger" className="btn-sm" onClick={() => xoa(openModalXoa)}>
                    Xóa
                </Button>
            </Modal.Footer>
        </Modal>
        <ContentHeader title="Danh sách chức năng" />
        <div className="card card-primary card-outline">
            <div className="card-header">
                <h3 className="card-title">Danh sách</h3>
                <div className="float-right card-tools">
                    <Button className="btn btn-success btn-sm pull-right" onClick={onThemMoi} type="button" title="Thêm mới" ><i className="fa fa-plus" /></Button>
                </div>
            </div>
            {loading ?
                <Loader small={true} color={'#2d4059'} secondaryColor={'#e5e5e5'} /> : 

                <div className="card-body">
                    <div className="row">
                        <div className="col-sm-6">
                            {loadingTree ?
                                <Spin indicator={antIcon} />
                                : <div id="treeView">
                                    <Tree
                                        showIcon
                                        showLine
                                        multiple={false}
                                        switcherIcon={<PlusOutlined rev="" />}
                                        onSelect={onSelect}
                                        treeData={treeData}
                                        selectedKeys={[chucNangSelected]}
                                    />
                                </div>
                            }
                        </div>
                        <div className="col-sm-6 custom-border">
                            <form className="form-horizontal" onSubmit={handleSubmit}>
                                <div className="form-group row" style={{ marginLeft: "20px" }}>
                                    <label className="col-sm-4 control-label">Chức năng cha:</label>
                                    <div className="col-sm-8">
                                        <ChucNangSelectTree
                                            name="idCha"
                                            value={values.idCha}
                                            onChange={onChange}
                                            noChoose
                                        />
                                    </div>
                                </div>
                                <div className="form-group row" style={{ marginLeft: "20px" }}>
                                    <label className="col-sm-4 control-label">Tên chức năng: <span className="text-red">*</span> </label>
                                    <div className="col-sm-8">
                                        <Form.Control
                                            id="tenChucNang"
                                            name="tenChucNang"
                                            type="text"
                                            placeholder="Tên chức năng"
                                            onChange={handleChange}
                                            value={values.tenChucNang}
                                            isValid={touched.tenChucNang && !errors.tenChucNang}
                                            isInvalid={touched.tenChucNang && !!errors.tenChucNang}
                                        />
                                        {touched.tenChucNang && errors.tenChucNang ? (
                                            <Form.Control.Feedback type="invalid">
                                                {errors.tenChucNang}
                                            </Form.Control.Feedback>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="form-group row" style={{ marginLeft: "20px" }}>
                                    <label className="col-sm-4 control-label">Mô tả:</label>
                                    <div className="col-sm-8">
                                        <Form.Control
                                            id="moTa"
                                            name="moTa"
                                            type="text"
                                            placeholder="Mô tả"
                                            onChange={handleChange}
                                            value={values.moTa}
                                            isValid={touched.moTa && !errors.moTa}
                                            isInvalid={touched.moTa && !!errors.moTa}
                                        />
                                        {touched.moTa && errors.moTa ? (
                                            <Form.Control.Feedback type="invalid">
                                                {errors.moTa}
                                            </Form.Control.Feedback>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="form-group row" style={{ marginLeft: "20px" }}>
                                    <label className="col-sm-4 control-label">Tên controller:</label>
                                    <div className="col-sm-8">
                                        <Form.Control
                                            id="controllerName"
                                            name="controllerName"
                                            type="text"
                                            placeholder="Tên controller"
                                            onChange={handleChange}
                                            value={values.controllerName}
                                            isValid={touched.controllerName && !errors.controllerName}
                                            isInvalid={touched.controllerName && !!errors.controllerName}
                                        />
                                        {touched.controllerName && errors.controllerName ? (
                                            <Form.Control.Feedback type="invalid">
                                                {errors.controllerName}
                                            </Form.Control.Feedback>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="form-group row" style={{ marginLeft: "20px" }}>
                                    <label className="col-sm-4 control-label">Tên action:</label>
                                    <div className="col-sm-8">
                                        <Form.Control
                                            id="actionName"
                                            name="actionName"
                                            type="text"
                                            placeholder="Tên action"
                                            onChange={handleChange}
                                            value={values.actionName}
                                            isValid={touched.actionName && !errors.actionName}
                                            isInvalid={touched.actionName && !!errors.actionName}
                                        />
                                        {touched.actionName && errors.actionName ? (
                                            <Form.Control.Feedback type="invalid">
                                                {errors.actionName}
                                            </Form.Control.Feedback>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="form-group row" style={{ marginLeft: "20px" }}>
                                    <label className="col-sm-4 control-label">URL:</label>
                                    <div className="col-sm-8">
                                        <Form.Control
                                            id="url"
                                            name="url"
                                            type="text"
                                            placeholder="URL"
                                            onChange={handleChange}
                                            value={values.url}
                                            isValid={touched.url && !errors.url}
                                            isInvalid={touched.url && !!errors.url}
                                        />
                                        {touched.url && errors.url ? (
                                            <Form.Control.Feedback type="invalid">
                                                {errors.url}
                                            </Form.Control.Feedback>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="form-group row" style={{ marginLeft: "20px" }}>
                                    <label className="col-sm-4 control-label">Icon:</label>
                                    <div className="col-sm-8">
                                        <Form.Control
                                            id="icon"
                                            name="icon"
                                            type="text"
                                            placeholder="icon"
                                            onChange={handleChange}
                                            value={values.icon}
                                            isValid={touched.icon && !errors.icon}
                                            isInvalid={touched.icon && !!errors.icon}
                                        />
                                        {touched.icon && errors.icon ? (
                                            <Form.Control.Feedback type="invalid">
                                                {errors.icon}
                                            </Form.Control.Feedback>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="form-group row" style={{ marginLeft: "20px" }}>
                                    <label className="col-sm-4 control-label">Thứ tự:</label>
                                    <div className="col-sm-8">
                                        <Form.Control
                                            id="thuTu"
                                            name="thuTu"
                                            type="number"
                                            min={1}
                                            placeholder="Thứ tự"
                                            onChange={handleChange}
                                            value={values.thuTu}
                                            isValid={touched.thuTu && !errors.thuTu}
                                            isInvalid={touched.thuTu && !!errors.thuTu}
                                        />
                                        {touched.thuTu && errors.thuTu ? (
                                            <Form.Control.Feedback type="invalid">
                                                {errors.thuTu}
                                            </Form.Control.Feedback>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="form-group row" style={{ marginLeft: "20px" }}>
                                    <div className="col-sm-4">
                                        <Form.Check
                                            onChange={(e) => {
                                                setFieldValue("hienThi", e.target.checked);
                                            }}
                                            type="switch"
                                            id="hienThi"
                                            name="hienThi"
                                            label="Hiển thị"
                                            checked={values.hienThi}
                                        />
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Check
                                            onChange={(e) => {
                                                setFieldValue("kichHoat", e.target.checked);
                                            }}
                                            type="switch"
                                            id="kichHoat"
                                            name="kichHoat"
                                            label="Kích hoạt"
                                            checked={values.kichHoat}
                                        />
                                    </div>
                                </div>
                                <div className="row button" style={{ borderTop: "1px solid #f4f4f4", padding: "10px" }}>
                                    <div className="col-sm-6">
                                        {
                                            showBtnXoa ? <Button className="float-left btn btn-danger btn-sm" onClick={() => { setOpenModalXoa(values.id || 0) }} style={{ "marginLeft": "10px" }} type="button" title="Xóa chức năng" >Xóa <i className="fas fa-trash-alt" /></Button> : null
                                        }
                                    </div>
                                    <div className="col-sm-6">
                                        <Button className="float-right btn btn-success btn-sm" type="submit" title="Lưu">Lưu <i className="fa fa-save" /></Button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            }
        </div>
    </section>
    );
};

export default DanhSachChucNang;
